import styled from 'styled-components';

export const StartNowMainWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        margin: 4rem 0 4rem 0;
        position:relative;

        @media(max-width:1023px){
            padding:1.5rem;
            margin:1.5rem 0 1.5rem 0;
        }
        @media only screen and (min-width:1024px) and (max-width:1350px){
            padding: 2rem 2rem;
        }
    `,
);

export const RoundedBack = styled.div(
  props => `
        width:75%;
        display: flex;
        height:22.6rem;
        background-color: #f2ecf3;
        align-items: center;
        justify-content: center;
        border-radius: 0 10rem 10rem 0;
        position: absolute;
        top:0;
        left:0;

        @media(max-width:1023px){
            width:95%;
            height:28rem;
            border-radius: 0 15rem 15rem 0;
        }
    `,
);

export const StartNowInnerWrap = styled.div(
  props => `
        max-width:1350px;
        margin:0 auto;
        display: flex;
        width:100%;
        justify-content: space-between;
        flex-direction: column;
        z-index:2;
        margin-top:4rem;

        @media(max-width:1023px){
            margin-top:2.5rem;
        }
        @media only screen and (min-width:1024px) and (max-width:1390px){
            margin-top:2rem;
        }
    `,
);

export const StartNowWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        align-items: center;
        max-width:70%;
        @media(max-width:1023px){
            flex-direction: column;
            max-width:90%;
            align-items: flex-start;
        }
        @media only screen and (min-width:1024px) and (max-width:1390px){
            max-width:75%;
        }
    `,
);

export const StartNowTextWrap = styled.div(
  props => `
        display: flex;
        flex-direction: column;
        width:80%;
    `,
);

export const StartNowHeadText = styled.h1(
  props => `
        font-size: 3.6rem;
        color: #0a2731
        font-weight: 900;
        line-height: 1.3;

        @media(max-width:1023px){
            font-size:2.4rem;
        }

        @media only screen and (min-width:1345px) and (max-width:1375px){
            margin-left: 2rem;
        }
    `,
);
export const StartNowText = styled.p(
  props => `
          font-size: 3.6rem;
          color: #0a2731
          font-weight: 900;
          line-height: 1.3;
  
          @media(max-width:1023px){
              font-size:2.4rem;
          }
  
          @media only screen and (min-width:1345px) and (max-width:1375px){
              margin-left: 2rem;
          }
      `,
);

export const StartNowSubText = styled.p(
  props => `
        padding-top:1.5rem;
        font-size: 1.6rem;
        color: #333333;
        @media(max-width:1023px){
            font-size:1.4rem;
            padding-top:0.75rem;
        }
        @media only screen and (min-width:1345px) and (max-width:1375px){
            margin-left: 2rem;
        }
    `,
);

export const StartNowButtonWrap = styled.div(
  props => `
        display: flex;
        margin-left: 7rem;
        width: 20.5rem;
        border:1px dashed #2077f7;
        border-radius: 4rem;
        padding: 0.8rem;

        @media(max-width:1023px){
            margin-top:1.5rem;
            width:18rem;
            height:7.2rem;
            margin-left:0;
        }
    `,
);

export const StartNowButton = styled.button(
  props => `
        width:100%;
        display: flex;
        height:5.6rem;
        border-radius: 5rem;
        background-image: linear-gradient(92deg, #53b2fe 0%, #065af3 130%);
        text-transform: ${props.theme.font.textTransform.upper};
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        align-items: center;
        justify-content: center;
        border: none;
        cursor: pointer;
    `,
);
